<template>

    <router-link v-if="to" class="sidebar-item" :class="{ active: isActive }" :to="to">
        <div class="label">
            <i v-if="icon" class="icon fa" :class="icon"></i>
            <span>{{ label }}</span>
        </div>
        <div v-if="locked"><i class="fas fa-lock text-danger" /></div>
        <div v-else-if="count >= 0" class="count">{{ count }}</div>
        <v-badge-new v-else-if="date" :date="date" size="sm" />
    </router-link>

    <a v-else class="sidebar-item" :href="href" target="_blank" :class="{ active: isActive }">
        <div class="label">
            <i v-if="icon" class="icon fa" :class="icon"></i>
            <span>{{ label }}</span>
        </div>
        <div v-if="locked"><i class="fas fa-lock text-danger" /></div>
        <div v-else-if="count >= 0" class="count">{{ count }}</div>
        <i class="fas fa-up-right-from-square text-muted"></i>
    </a>

</template>

<style scoped lang="scss">

    .sidebar-item {
        @include font-semibold(12px);
        align-items: center;
        border-radius: 5px;
        color: $color-text;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        padding: 8px 10px;
        text-align: left;
        text-decoration: none;
        transition: .3s background-color;
        user-select: none;
        &:hover {
            background: $color-highlight;
        }
        &.active {
            background: $color-highlight;
            color: $color-primary;
            i {
                color: $color-primary;
            }
        }
        .icon {
            margin: 0 5px 0 0;
            text-align: center;
            transition: .3s color;
            width: 20px;
        }
        .label {
            display: flex;
            line-height: 1.2em;
            overflow: hidden;
            white-space: nowrap;
            span {
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                transition: .3s color;
                max-width: 100%;
            }
        }
        .count {
            @include font-bold(12px);
            align-items: center;
            background-color: $color-rule;
            border-radius: 9px;
            color: $color-text;
            display: flex;
            font-size: 8px;
            height: 18px;
            justify-content: center;
            line-height: normal;
            margin-left: 5px;
            min-width: 26px;
            padding: 0 8px;
        }
    }

</style>

<script>

import BadgeNew from '@cmp/BadgeNew';

export default {

    components: {
        'v-badge-new': BadgeNew,
    },

    props: {
        icon: {
            type: String,
        },
        label: {
            type: String,
            default: 'Title',
        },
        to: {
            type: Object,
            default: null,
        },
        href: {
            type: String,
            default: null,
        },
        active: {
            type: Boolean,
            default: null,
        },
        date: {
            type: String,
            validator: function(value) {
                return /^\d{4}-\d{2}-\d{2}$/.test(value);
            },
        },
        count: {
            type: Number,
        },
        locked: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        isActive() {
            if (this.active !== null) {
                return this.active;
            } else if (this.to) {
                return this.$route.name.startsWith(this.to.name);
            }
            return false;
        },

    },

}

</script>